import axiosHandler from "../../Intersepter/axiosInstance";

export const verifyRazorpayPayment = async (paymentDetails) => {
  try {
    const payload = {
      razorpay_order_id: paymentDetails.response.razorpay_order_id,
      razorpay_payment_id: paymentDetails.response.razorpay_payment_id,
      razorpay_signature: paymentDetails.response.razorpay_signature,
      before_balance: paymentDetails.balance,
    };

    const response = await axiosHandler.post(
      "/payment/verify-payment",
      payload
    );

    if (!response.data.success) {
      throw new Error(response.data.message || "Verification failed");
    }

    return response.data; // Return successful response
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Payment verification failed"
    );
  }
};

// Service to handle API requests related to payment transactions.
export const fetchPaymentTransactions = async (
  userId,
  dateRange = null,
  start_date = null,
  end_date = null
) => {
  try {
    // Ensure userId is present
    if (!userId) {
      throw new Error("User ID is required to fetch payment transactions.");
    }

    // Construct the base URL with the userId
    let url = `/ledger/data/${userId}`;
    const queryParams = [];

    // Add optional query parameters if they are provided
    if (dateRange) queryParams.push(`filter=${dateRange}`);
    if (start_date && end_date)
      queryParams.push(`start_date=${start_date}&end_date=${end_date}`);

    // Append query parameters to the URL if any exist
    if (queryParams.length > 0) {
      url += `?${queryParams.join("&")}`;
    }

    // Perform the API request
    const response = await axiosHandler.get(url);

    return response.data; // Return the full response data
  } catch (error) {
    console.error("Error fetching payment transactions:", error.message);

    // Throw a meaningful error for the caller to handle
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch payment transactions. Please try again later."
    );
  }
};
